"use strict";
import { PLAYWRIGHT_CONNECT_ADDRESS } from "components/Web3Provider/constants";
import { injectedWithFallback } from "components/Web3Provider/injectedWithFallback";
import { WC_PARAMS } from "components/Web3Provider/walletConnect";
import { embeddedWallet } from "connection/EmbeddedWalletConnector";
import { UNISWAP_LOGO } from "ui/src/assets";
import { UNISWAP_WEB_URL } from "uniswap/src/constants/urls";
import { config } from "uniswap/src/config";
import { getChainInfo } from "uniswap/src/features/chains/chainInfo";
import { ALL_CHAIN_IDS, UniverseChainId } from "uniswap/src/features/chains/types";
import { isTestnetChain } from "uniswap/src/features/chains/utils";
import { isPlaywrightEnv } from "utilities/src/environment/env";
import { logger } from "utilities/src/logger/logger";
import { createClient } from "viem";
import { createConfig, fallback, http } from "wagmi";
import { coinbaseWallet, mock, safe, walletConnect } from "wagmi/connectors";
export const orderedTransportUrls = (chain) => {
  const orderedRpcUrls = [
    ...chain.rpcUrls.default?.http ?? [],
    ...chain.rpcUrls.public?.http ?? [],
    ...chain.rpcUrls.fallback?.http ?? [],
    ...chain.rpcUrls.interface?.http ?? []
  ];
  const hasInfuraKey = Boolean(config.infuraKey);
  const filtered = orderedRpcUrls.filter(Boolean).filter((url) => hasInfuraKey ? true : typeof url === "string" ? !url.includes("infura.io") : true);
  return Array.from(new Set(filtered));
};
function createWagmiConnectors(params) {
  const { includeMockConnector } = params;
  const baseConnectors = [
    injectedWithFallback(),
    walletConnect(WC_PARAMS),
    embeddedWallet(),
    coinbaseWallet({
      appName: "Uniswap",
      // CB SDK doesn't pass the parent origin context to their passkey site
      // Flagged to CB team and can remove UNISWAP_WEB_URL once fixed
      appLogoUrl: `${UNISWAP_WEB_URL}${UNISWAP_LOGO}`,
      reloadOnDisconnect: false
    }),
    safe()
  ];
  return includeMockConnector ? [
    ...baseConnectors,
    mock({
      features: {},
      accounts: [PLAYWRIGHT_CONNECT_ADDRESS]
    })
  ] : baseConnectors;
}
function createWagmiConfig(params) {
  const { connectors, onFetchResponse = defaultOnFetchResponse } = params;
  return createConfig({
    chains: [getChainInfo(UniverseChainId.Mainnet), ...ALL_CHAIN_IDS.map(getChainInfo)],
    connectors,
    client({ chain }) {
      return createClient({
        chain,
        batch: { multicall: true },
        pollingInterval: 12e3,
        transport: fallback(
          orderedTransportUrls(chain).map(
            (url) => http(url, { onFetchResponse: (response) => onFetchResponse(response, chain, url) })
          )
        )
      });
    }
  });
}
const defaultOnFetchResponse = (response, chain, url) => {
  if (response.status !== 200) {
    const message = `RPC provider returned non-200 status: ${response.status}`;
    if (isTestnetChain(chain.id)) {
      logger.warn("wagmiConfig.ts", "client", message, {
        extra: {
          chainId: chain.id,
          url
        }
      });
    } else {
      logger.error(new Error(message), {
        extra: {
          chainId: chain.id,
          url
        },
        tags: {
          file: "wagmiConfig.ts",
          function: "client"
        }
      });
    }
  }
};
const defaultConnectors = createWagmiConnectors({
  includeMockConnector: isPlaywrightEnv()
});
export const wagmiConfig = createWagmiConfig({ connectors: defaultConnectors });
